export default __webpack_public_path__ + "static/media/verband-fuer-aktuelle-Musik-Hamburg-logo-bt.130c5bb3.jpg";